import React, { useState } from 'react'
import Footer from '../Components/Footer'
import Header from '../Components/Header'
import SideBar from '../Components/Sideabar'

const policies = [
    {
        text: `Last Updated: Feb 2025
Welcome to Hulluware("Website," "Platform," "Service"). This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our Platform. By accessing or using our Platform, you agree to the terms of this Privacy Policy. If you do not agree with this policy, you must not use our services.`
    },
    {
        title: '1. Information We Collect',
        text: 'We may collect the following types of information:'
    },
    {
        title: '1.1 Personal Information',
        text: `Registration Data: Name, email address, phone number, and password when you create an account.
Payment Information: Billing address, payment method, and transaction details when you purchase a course
Profile Information: Profile picture, bio, and other details you choose to provide.
Communications: Messages, feedback, or inquiries you send to us.
Log Data: IP address, browser type, operating system, and pages visited.
Device Information: Device type, unique device identifiers, and mobile network information.
Cookies and Tracking Technologies: We use cookies, web beacons, and similar technologies to track user activity and preferences.`
    },
    {
        title: '1.3 Third-Party Data',
        text: `Social Media: If you log in via social media platforms (e.g., Google, Facebook), we may collect information from those accounts.
Analytics: We may use third-party analytics tools to collect data about your use of the Platform.`
    },
    {
        title: '2. How We Use Your Information',
        text: `We use your information for the following purposes:
To provide, maintain, and improve our Platform
To process transactions and send you confirmations.
To communicate with you about updates, promotions, and support
To personalize your experience and recommend relevant courses.
To monitor and analyze usage trends and preferences.
To enforce our Terms and Conditions and protect the security of our Platform.`
    },
    {
        title: '3. How We Share Your Information',
        text: `We may share your information in the following circumstances:
With Instructors: If you enroll in a course, we may share your name and email with the instructor for communication purposes.
With Service Providers: We may share data with third-party vendors who assist us in operating the Platform (e.g., payment processors, hosting providers).
For Legal Reasons: We may disclose information if required by law or to protect our rights, property, or safety.
Business Transfers: In the event of a merger, acquisition, or sale of assets, your information may be transferred to the new owner.`
    },
    {
        title: '4. Data Security',
        text: `We implement reasonable security measures to protect your information from unauthorized access, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.`
    },
    {
        title: '5. Your Rights and Choices',
        text: `Depending on your location, you may have the following rights
Access: Request a copy of the personal information we hold about you.
Correction: Request corrections to inaccurate or incomplete information
Deletion: Request deletion of your personal information, subject to legal obligations
Opt-Out: Opt out of receiving promotional emails by following the unsubscribe link in the email.
Cookies: Manage or disable cookies through your browser settings.
To exercise these rights, please contact us at info@hulluware.com`
    },
    {
        title: '6. Third-Party Links',
        text: 'Our Platform may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these third parties. We encourage you to review their privacy policies before providing any information.'
    },
    {
        title: '7. International Data Transfers',
        text: 'Your information may be transferred to and processed in countries other than your own, where data protection laws may differ. By using the Platform, you consent to such transfers.'
    },
    {
        title: '8. Children’s Privacy',
        text: 'Our Platform is not intended for children under the age of 13. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child without parental consent, we will take steps to delete such information.'
    },
    {
        title: '9. Changes to This Privacy Policy',
        text: 'We may update this Privacy Policy from time to time. Changes will be effective upon posting on the Platform. Your continued use of the Platform constitutes acceptance of the updated policy. We encourage you to review this policy periodically.'
    },
    {
        title: '10. Contact Us',
        text: `If you have any questions or concerns about this Privacy Policy, please contact us at:
        Email:info@hulluware.com
        Phone: +251962444466
        Address: Addis Ababa, Ethiopia`
    }   
    
]

export default function Privacy() {
    return (
      <div className='w-full flex bg-[#f2f2f2] h-screen overflow-hidden'>
        <div className='flex-1 flex flex-col overflow-auto pt-[60px]'>
            <Header />
            <div className='flex-1 p-4'>
                <h1 className='text-center text-[30px] font-bold'>Privacy Policy</h1>
                {policies.map(policy => (
                    <>
                        {policy.title && <p className='text-sm text-center font-bold text-md mt-4'>{policy.title}</p>}
                        <p className='text-sm mt-2 whitespace-pre-wrap'>{policy.text}</p>
                    </>
                ))}
            </div>
            <Footer />
        </div>
      </div>
    )
  }